<template>
  <div :class="if_selected" class="row ml-2">
    <div class="w-100">
      <div class="md-layout">
        <label for="name">
          <b class="md-layout-item md-caption">{{ tx(model) }}</b></label
        >
        <helpWidget
          v-if="this.attributes.help_img || help_key"
          class="md-layout-item pl-3"
          :help="help_key"
          :help_img="
            this.attributes.help_img
              ? `${this.IREALCONFIG.static_ressources}/${this.attributes.help_img}.png`
              : ''
          "
          :help_style="this.attributes.help_style"
        ></helpWidget>
      </div>
      <br />
      <div class="radio-list" :style="`${this.attributes.style}`">
        <div
          v-for="o in options"
          :key="o"
          :class="
            attributes.class
              ? attributes.class
              : 'form-check form-check-radio d-flex'
          "
        >
          <label class="form-check-label"
            >{{ tx(`${model}_${o}`) }}

            <input
              class="form-check-input"
              type="radio"
              :value="o"
              v-model="value"
              :disabled="disabled"
            />

            <span class="circle">
              <span class="check"></span>
            </span>
          </label>
          <helpWidget
            v-if="help_img_options.indexOf(`${o}`) >= 0 || attributes.help"
            class="md-layout-item"
            :help="`${help_key}_${o}`"
            :help_img="`${IREALCONFIG.static_ressources}/${o}.png`"
          ></helpWidget>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import componentMixin from "ireal-vue/mixins/component-mixin.js";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import dataComponentMixin from "ireal-vue/mixins/data-component-mixin.js";
import Bus from "../services/bus.js";

export default {
  name: "radio-button-component",
  mixins: [inputComponentMixin, componentMixin, dataComponentMixin],
  data() {
    return {
      if_selected: "",
    };
  },
  async mounted() {
    this.update_selected();
this.value = this.attributes.default
        this.$store.commit("setParam", {
          param: this.model,
          value: this.attributes.default,
        });
console.log(this.value,this.$store.getters.testParams)


    Bus.$on("selected-changed", () => {
      this.update_selected();
    });
    this.$store.commit("setParam", {
          param: this.model,
          value: this.value,
        });
this.value = this.attributes.default
  },
  created(){
    this.$store.commit("setParam", {
          param: this.model,
          value: this.value,
        });
  },
  created(){
    this.$store.commit("setParam", {
          param: this.model,
          value: this.value,
        });
  },
  computed: {
    options() {
      if (this.attributes.options === undefined) return [];
      else return this.attributes.options.split("|");
    },
    help_img_options() {
      if (this.attributes.help_img_options === undefined) return [];
      else return this.attributes.help_img_options.split("|");
    },
    id_selected_tab() {
      if (this.attributes.id_selected === undefined) return [];
      else return this.attributes.id_selected.split("|");
    },
    model_dependance_tab() {
      if (this.attributes.model_dependance === undefined) return [];
      else return this.attributes.model_dependance.split("|");
    },
  },
  methods: {
    prepare() {},
    recommence() {
      this.update_selected();
    },
  },
};
</script>
<style scoped>
.md-layout-item {
  display: flex !important;
}
.radio-list {
  width: 100%;
  white-space: normal;
}
</style>
